/* eslint-disable import/prefer-default-export */
import formatComment from '../../utils/formatComment';

export const groupCommentByPostReducer = (acc, comment) => {
  const formattedComment = formatComment(comment);
  const result = { ...acc };
  const postId = comment.entityId;
  result[postId] = [...(acc[postId] || []), formattedComment];
  return result;
};
